


import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const AboutOverview = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        jobRole: "Web Designer",
        department: "IT",
        designation: "Web Designer",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">About</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    {/* First Role */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">Job Role</label>
                        {isEditing ? (
                            <input type="text" name="jobRole" className="form-control input-me f-14" value={formData.jobRole} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.jobRole}</p>
                        )}
                    </div>

                    {/* Current Role */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">Department</label>
                        {isEditing ? (
                            <select name="department" className="form-control input-me f-14" value={formData.department} onChange={handleChange}>
                                <option>Accounting Department</option>
                                <option>Audit Department</option>
                                <option>CEO Office</option>
                                <option>Department</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.department}</p>
                        )}
                    </div>
                    {/* Notice Period */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">Designation</label>
                        {isEditing ? (
                            <select name="designation" className="form-control input-me f-14" value={formData.designation} onChange={handleChange}>
                                <option>Web Designer</option>
                                <option>PHP Developer</option>
                                <option>Magento Developer</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.designation}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutOverview;
